<script setup>
import { onMounted, ref } from 'vue';

defineProps({
    modelValue: String,
});

defineEmits(['update:modelValue']);

const input = ref(null);

onMounted(() => {
    if (input.value.hasAttribute('autofocus')) {
        input.value.focus();
    }
});

defineExpose({ focus: () => input.value.focus() });
</script>

<template>
    <input
        ref="input"
        :value="modelValue"
        class="text-[#272529] border-[#DEDEE3] focus:border-[#E89F8D] focus:ring-[#E89F8D] rounded-lg shadow-sm disabled:opacity-50"
        @input="$emit('update:modelValue', $event.target.value)"
    >
</template>
